/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsLeft = createReactComponent("outline", "arrows-left", "IconArrowsLeft", [["path", { "d": "M3 7l18 0", "key": "svg-0" }], ["path", { "d": "M6 20l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M6 4l-3 3l3 3", "key": "svg-2" }], ["path", { "d": "M3 17l18 0", "key": "svg-3" }]]);

export { IconArrowsLeft as default };
//# sourceMappingURL=IconArrowsLeft.mjs.map
